import Vue from 'vue'
import BzbsApi from '@/core/Http/BzbsApi.js'
import Cache from '@/helper/Cache.js'
import Account from '@/helper/AccountHelper.js'

/**
 * @method getPoint
 * @method getCustomerStore
 * @method getProfile
 * @method getCampaign
 * @method apiVerifyCustomerUser
 * @method apicompanyuser
 */

export default {
  config: function () {
    return Vue.bzbsConfig
  },
  token: function () {
    return Account.getCacheToken() ? Account.getCacheToken() : null
  },
  app_id: function () {
    if (Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')) != null) {
      if (
        Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')).appId !=
        undefined
      ) {
        return Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')).appId
      } else {
        return Account.getCacheCustom('app_id')
      }
    } else {
      return Account.getCacheCustom('app_id')
    }
  },
  apiVerifyCustomerUser: function (params) {
    if (!params.device_app_id) {
      params.device_app_id = this.config().client_id
    }
    var strUrl = this.config().bzbModuleUrl + '/crmpluscustomer/companyuser'
    return BzbsApi.connectBzbsGet(strUrl, null, params, this.app_id())
  },
  apicompanyuser: function (params) {
    var token
    if (this.token()) {
      token = this.token()
    } else {
      token = Account.getCacheToken() ? Account.getCacheToken() : null
    }
    if (!params.device_app_id) {
      params.device_app_id = this.config().client_id
    }
    var strUrl = this.config().bzbModuleUrl + '/crmpluscustomer/use_companyuser'
    return BzbsApi.connectBzbsPost(strUrl, token, params)
  },
}
